module.exports = __webpack_public_path__ + "img/banner-20230701.aa23a543.jpg";